import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { string, ref, ObjectSchema, object } from "yup";

export type ChangePasswordFormValues = {
  oldPassword: string;
  newPassword: string;
  repeatNewPassword: string;
};

const changePasswordValidationSchema: ObjectSchema<ChangePasswordFormValues> = object({
    oldPassword: string().required("Old password field is required"),
    newPassword: string().required("New password field is required"),
    repeatNewPassword: string()
      .oneOf([ref("newPassword")], "Passwords must match")
      .required("Reenter password field is required"),
  })
  .required();

export function useChangePasswordForm() {
  return useForm<ChangePasswordFormValues>({
    resolver: yupResolver(changePasswordValidationSchema),
    reValidateMode: "onChange",
  });
}
